import React, { FC } from 'react';
import { ThemeProvider } from '@seddi/ui-kit';
import { AppAuth, AppLoad, AppAuthLoad } from './app';
import { AuthProvider } from './auth';
import { Home } from './home';
import { SiteProvider } from './sites';
import { theme } from './styles/theme';

export const Main: FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <SiteProvider>
        <AuthProvider>
          <AppLoad>
            <AppAuth>
              <AppAuthLoad>
                <Home />
              </AppAuthLoad>
            </AppAuth>
          </AppLoad>
        </AuthProvider>
      </SiteProvider>
    </ThemeProvider>
  );
};
